export default "__VITE_ASSET__2hUpiSTq__"